import React, { useState, useEffect } from "react";
import './App.css';

const TatilVeIzin = () => {
  const [cumartesi, setCumartesi] = useState(false);
  const [pazar, setPazar] = useState(false);
  const [resmiTatiller, setResmiTatiller] = useState(false);

  const [tatiller, setTatiller] = useState([]);

  const [baslangic, setBaslangic] = useState("");
  const [bitis, setBitis] = useState("");
  const [izinGunleri, setIzinGunleri] = useState(null);

  useEffect(() => {
    const fetchTatiller = async () => {
      try {
        const response = await fetch("https://api.idekod.com.tr/tatiller");
        const data = await response.json();
        setTatiller(data.tatiller);
      } catch (error) {
        console.error("Hata:", error);
      }
    };
    fetchTatiller();
  }, []);

  const handleAyarKaydet = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://api.idekod.com.tr/ayarlar", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          cumartesiCalisma: cumartesi,
          pazarCalisma: pazar,
          resmiTatilCalisma: resmiTatiller,
        }),
      });
      const data = await response.json();
      alert(data.message);
    } catch (error) {
      console.error("Hata:", error);
    }
  };

  const handleIzinHesapla = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://api.idekod.com.tr/izin-hesapla", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ baslangic, bitis }),
      });
      const data = await response.json();
      setIzinGunleri(data.izinGunleri);
    } catch (error) {
      console.error("Hata:", error);
    }
  };

  return (
    <div className="page">
      <div className="page__head">
        <div>
          <h1 className="page__title">Tatil ve İzin Yönetimi</h1>
          <p className="page__subtitle">Çalışma günlerini ayarlayın ve iş günü hesaplayın</p>
        </div>
      </div>

      <div className="card">
        <div className="card__header">
          <h2 className="card__title">Tatil Ayarları</h2>
        </div>

        <div className="card__body">
          <form onSubmit={handleAyarKaydet} className="form">
            <div className="form-grid form-grid--three">
              <label className="checkbox-field" htmlFor="cumartesi">
                <input type="checkbox" id="cumartesi" checked={cumartesi} onChange={(e) => setCumartesi(e.target.checked)} />
                <span>Cumartesi Çalışma</span>
              </label>
              <label className="checkbox-field" htmlFor="pazar">
                <input type="checkbox" id="pazar" checked={pazar} onChange={(e) => setPazar(e.target.checked)} />
                <span>Pazar Çalışma</span>
              </label>
              <label className="checkbox-field" htmlFor="resmiTatiller">
                <input type="checkbox" id="resmiTatiller" checked={resmiTatiller} onChange={(e) => setResmiTatiller(e.target.checked)} />
                <span>Resmi Tatiller Çalışma</span>
              </label>
            </div>
            <button type="submit" className="btn btn--primary">Kaydet</button>
          </form>
        </div>
      </div>

      <div className="card">
        <div className="card__header">
          <h2 className="card__title">Tatil Listesi</h2>
        </div>
        <div className="card__body">
          {tatiller.length === 0 ? (
            <p className="form-helper">Tatil bulunamadı.</p>
          ) : (
            <ul style={{ paddingLeft: 'var(--space-5)', margin: 0 }}>
              {tatiller.map((tatil, index) => (
                <li key={index}>
                  <strong>{tatil.tarih}</strong> - {tatil.aciklama || "Resmi Tatil"}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      <div className="card">
        <div className="card__header">
          <h2 className="card__title">İzin Hesaplama</h2>
        </div>
        <form onSubmit={handleIzinHesapla} className="card__body form">
          <div className="form-grid">
            <div className="form-field">
              <label className="form-label">Başlangıç Tarihi</label>
              <input type="date" value={baslangic} onChange={(e) => setBaslangic(e.target.value)} className="form-control" />
            </div>
            <div className="form-field">
              <label className="form-label">Bitiş Tarihi</label>
              <input type="date" value={bitis} onChange={(e) => setBitis(e.target.value)} className="form-control" />
            </div>
          </div>
          <button type="submit" className="btn btn--primary">Hesapla</button>
          {izinGunleri !== null && (
            <div className="info-banner">
              Toplam İş Günü: <strong>{izinGunleri} gün</strong>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default TatilVeIzin;
